import {useRef, useState} from 'react';
import {useInstantSearch, useSearchBox, type UseSearchBoxProps} from 'react-instantsearch';
import {useConfigContext} from "@/ConfigProvider";
import {Panel} from "@/instantsearch/components/Panel";

export function SearchBox(props: UseSearchBoxProps) {
    const {tc} = useConfigContext();
    const {query, refine} = useSearchBox(props);
    const {status} = useInstantSearch();
    const [inputValue, setInputValue] = useState(query);
    const inputRef = useRef(null);
    const isSearchStalled = status === 'stalled';
    function setQuery(newQuery: string) {
        setInputValue(newQuery);
        refine(newQuery);
    }

    return (
        <Panel title={"SUCHE"}>
            <div className="algoliaSearchSearchBox">
                <form
                    action=""
                    role="search"
                    noValidate
                    className="algoliaSearchSearchBox__form"
                >
                    <input
                        ref={inputRef}
                        autoComplete="off"
                        autoCorrect="off"
                        autoCapitalize="off"
                        placeholder={tc.search}
                        spellCheck={false}
                        maxLength={512}
                        id={"searchBox"}
                        className={"algoliaSearchSearchBox__input"}
                        type="search"
                        value={inputValue}
                        onChange={(event) => {
                            setQuery(event.currentTarget.value);
                        }}
                        autoFocus
                    />
                    <span hidden={!isSearchStalled} aria-hidden={true}>{tc.search}…</span>
                </form>
            </div>
        </Panel>
    );
}